import { useState } from "react";
import { DueDiligenceTier } from "../../Types-DTOs/DueDiligence";
import { useDueDiligence } from "./index";
import { isErr } from "../../Utils/Result";
import { eventBus } from "../../EventBus";
import { Notification } from "../../../Components/Notifications";

export const useDueDiligencePayment = (caseId: string | undefined, tier: DueDiligenceTier | null | undefined) => {
  const [isPayingNow, setIsPayingNow] = useState(false);
  const { getPaymentUrl } = useDueDiligence();

  const handlePayNow = async () => {
    if (!caseId || !tier || isPayingNow) return;
    setIsPayingNow(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = await getPaymentUrl(caseId, tier);
    if (!isErr(result)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      window.location.href = (result.value as any).paymentUrl;
    } else {
      setIsPayingNow(false);
      eventBus.emit("NOTIFICATION", Notification.buildNotification("error", "Error obteniendo link de pago"));
    }
  };

  return { isPayingNow, handlePayNow };
};
